
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

  Flits(document).on('Flits:SocialLoginAutomaticCode:Loaded', function(event){  
    var data = event.detail;
    Flits('<div id="flits-social-header"><h3>or</h3></div>').insertBefore(event.detail.cloneNode);
  });

  <!--   LOGIN REDIRECT -->
 
  Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
    setTimeout(function(){
      if (location.pathname.indexOf("/account") == -1){  
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }, 800);
  });

  Flits(window).load(function() {  
    if (location.pathname.indexOf("/account") == -1){     
      if (location.pathname.indexOf("checkout") != -1)
      {
        Flits.setLocalStorage('flits_before_login_url',location.pathname);
      }else{
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }
 
  });

  <!--   LOGOUT REDIRECT -->
Flits(document).on('Flits:AccountPage:Loaded', function(event){  
  Flits('.flits-current-time').parent().attr('style', 'display: none !important');
  setTimeout(function(){
   var REDIRECT_PATH = "/account/login";   
    var logoutBtn = document.querySelector('a[href^="/account/logout"]');
    logoutBtn.addEventListener('click', function() {
      fetch(logoutBtn.href).then(() => window.location.href = REDIRECT_PATH)
    });
    }, 100);
});

}(Flits));
